import { Box, BoxProps, Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { IoSearch } from 'react-icons/io5';
import { HelivanColor } from './HelivanColor';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  /** Wrapper width/flex props, e.g. responsive sizing per page. */
  containerProps?: BoxProps;
}

/**
 * Compact, borderless search input shared across the Agents and Watches pages.
 * Sits to the right of the page's filter pills.
 */
export const SearchInput = ({
  value,
  onChange,
  placeholder = 'Search…',
  containerProps,
}: SearchInputProps) => {
  return (
    <Box
      width={{ base: 'full', sm: '220px', md: '280px' }}
      flexShrink={0}
      {...containerProps}
    >
      <InputGroup size="sm">
        <InputLeftElement pointerEvents="none">
          <IoSearch size={16} color={HelivanColor.text.blueMid} />
        </InputLeftElement>
        <Input
          bg={HelivanColor.background.secondary}
          borderRadius="6px"
          border="none"
          placeholder={placeholder}
          _placeholder={{ color: HelivanColor.text.blueMid }}
          textColor="black"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </InputGroup>
    </Box>
  );
};
